module.exports = __webpack_public_path__ + "img/recomend.1cb9e5b8.png";